export function Footer() {
  return (
    <footer>
      &copy; {new Date().getFullYear()} MyNews Inc. All rights reserved.
    </footer>
  )
}
